// // // export default Sidebar;
// // import { useState, useRef, useEffect, useCallback } from 'react';
// // import { NavLink, useLocation, useNavigate } from 'react-router-dom';
// // import { useSelector } from 'react-redux';
// // import {
// //     FiHome, FiUsers, FiAward, FiMapPin, FiUser, FiActivity,
// //     FiDollarSign, FiShield, FiSettings, FiChevronLeft,
// //     FiChevronRight, FiChevronDown, FiDribbble, FiKey, FiLock,
// //     FiTarget, FiPercent,
// // } from 'react-icons/fi';
// // import styles from './Sidebar.module.scss';

// // const menuItems = [
// //     { path: '/dashboard',              icon: FiHome,       label: 'Dashboard',              roles: ['super-admin', 'admin'] },
// //     { path: '/admin-management',       icon: FiShield,     label: 'Vendor Management',      roles: ['super-admin'] },
// //     { path: '/court-management',       icon: FiMapPin,     label: 'Court Management',       roles: ['super-admin', 'admin'] },
// //     { path: '/tournaments',            icon: FiAward,      label: 'Tournaments Management', roles: ['super-admin', 'admin'] },
// //     { path: '/coach-management',       icon: FiUser,       label: 'Coach Management',       roles: ['super-admin', 'admin'] },
// //     { path: '/referee-management',     icon: FiUser,       label: 'Referee Management',     roles: ['super-admin', 'admin'] },
// //     { path: '/sports-management',      icon: FiTarget,     label: 'Sports Management',      roles: ['super-admin'] },
// //     { path: '/user-management',        icon: FiUsers,      label: 'Customer Management',    roles: ['super-admin', 'admin'] },
// //     {
// //         icon: FiSettings,
// //         label: 'Roles & Permissions',
// //         roles: ['super-admin'],
// //         submenu: [
// //             { path: '/roles-list',        icon: FiKey,   label: 'Roles'         },
// //             { path: '/user-list',         icon: FiUsers, label: 'User Creation' },
// //             { path: '/roles-permissions', icon: FiLock,  label: 'Page Access'   },
// //         ],
// //     },
// //     { path: '/payments-revenue',       icon: FiDollarSign, label: 'Payments & Revenue',     roles: ['super-admin'] },
// //     { path: '/commmission-management', icon: FiPercent,    label: 'Commission Management',  roles: ['super-admin'] },
// //     { path: '/live-score-update',      icon: FiActivity,   label: 'Live Score Update',      roles: ['referee', 'super-admin', 'admin'] },
// // ];

// // export const SIDEBAR_EXPANDED  = 240;
// // export const SIDEBAR_COLLAPSED = 62;
// // export const BP_MOBILE         = 768;
// // export const BP_AUTO_COLLAPSE  = 1280;

// // const itemKey = (item) => item.path ?? item.label;

// // const Sidebar = ({ collapsed, onToggle, onOpen }) => {  // ← onOpen added
// //     const location = useLocation();
// //     const navigate = useNavigate();
// //     const { user }  = useSelector((state) => state.auth);

// //     const [openSubmenu, setOpenSubmenu] = useState(null);
// //     const [hoveredItem, setHoveredItem] = useState(null);
// //     const [popupTop,    setPopupTop]    = useState(0);
// //     const [mobileOpen,  setMobileOpen]  = useState(false);

// //     const [isMobile, setIsMobile] = useState(
// //         () => window.innerWidth < BP_MOBILE
// //     );
// //     const [autoCollapsed, setAutoCollapsed] = useState(
// //         () => window.innerWidth < BP_AUTO_COLLAPSE
// //     );

// //     const itemRefs   = useRef({});
// //     const prevAutoCol = useRef(window.innerWidth < BP_AUTO_COLLAPSE); // ← added

// //     // ── Resize ────────────────────────────────────────────────────────────
// //     useEffect(() => {
// //         const onResize = () => {
// //             const w = window.innerWidth;
// //             const nowMobile  = w < BP_MOBILE;
// //             const nowAutoCol = w < BP_AUTO_COLLAPSE;

// //             setIsMobile(nowMobile);
// //             setAutoCollapsed(nowAutoCol);
// //             if (nowMobile) setMobileOpen(false);

// //             // Reset manual toggle when crossing the breakpoint boundary
// //             if (prevAutoCol.current !== nowAutoCol) {
// //                 onOpen();
// //                 prevAutoCol.current = nowAutoCol;
// //             }
// //         };
// //         window.addEventListener('resize', onResize);
// //         return () => window.removeEventListener('resize', onResize);
// //     }, [onOpen]);  // ← onOpen in deps

// //     // ── Close drawer on navigation ────────────────────────────────────────
// //     useEffect(() => { setMobileOpen(false); }, [location.pathname]);

// //     // ── Keep submenu open for active child route ──────────────────────────
// //     useEffect(() => {
// //         const active = menuItems.find(
// //             (item) => item.submenu?.some(
// //                 (sub) =>
// //                     location.pathname === sub.path ||
// //                     location.pathname.startsWith(sub.path + '/')
// //             )
// //         );
// //         setOpenSubmenu(active ? itemKey(active) : null);
// //     }, [location.pathname]);

// //     // ── FIXED: toggle from the autoCollapsed default ──────────────────────
// //     // autoCollapsed=true  (small screen) → default is CLOSED → collapsed=false means OPEN
// //     // autoCollapsed=false (large screen) → default is OPEN  → collapsed=true  means CLOSED
// //     const isDesktopCollapsed = !isMobile && (autoCollapsed ? !collapsed : collapsed); // ← FIXED

// //     const showLabel = isMobile ? mobileOpen : !isDesktopCollapsed;

// //     useEffect(() => {
// //         if (isDesktopCollapsed) setOpenSubmenu(null);
// //     }, [isDesktopCollapsed]);

// //     const filtered = menuItems.filter(
// //         (item) => !user || item.roles.includes(user.role)
// //     );

// //     const isParentActive = (item) => {
// //         if (item.submenu) {
// //             return item.submenu.some(
// //                 (sub) =>
// //                     location.pathname === sub.path ||
// //                     location.pathname.startsWith(sub.path + '/')
// //             );
// //         }
// //         if (!item.path) return false;
// //         return (
// //             location.pathname === item.path ||
// //             location.pathname.startsWith(item.path + '/')
// //         );
// //     };

// //     const handleParentClick = (item) => {
// //         if (!item.submenu) return;
// //         if (showLabel) {
// //             const key = itemKey(item);
// //             setOpenSubmenu((prev) => (prev === key ? null : key));
// //         } else {
// //             navigate(item.submenu[0].path);
// //         }
// //     };

// //     const handleMouseEnter = useCallback((item) => {
// //         if (!item.submenu || !isDesktopCollapsed) return;
// //         const key = itemKey(item);
// //         const el  = itemRefs.current[key];
// //         if (el) setPopupTop(el.getBoundingClientRect().top);
// //         setHoveredItem(key);
// //     }, [isDesktopCollapsed]);

// //     const handleMouseLeave = useCallback((item) => {
// //         if (!item.submenu || !isDesktopCollapsed) return;
// //         setHoveredItem(null);
// //     }, [isDesktopCollapsed]);

// //     const sidebarClass = [
// //         styles.sidebar,
// //         isDesktopCollapsed ? styles.collapsed  : '',
// //         mobileOpen         ? styles.mobileOpen : '',
// //     ].filter(Boolean).join(' ');

// //     return (
// //         <>
// //             {isMobile && (
// //                 <button
// //                     className={styles.mobileToggle}
// //                     onClick={() => setMobileOpen((p) => !p)}
// //                     aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
// //                 >
// //                     <span className={`${styles.hamburger} ${mobileOpen ? styles.hOpen1 : ''}`} />
// //                     <span className={`${styles.hamburger} ${mobileOpen ? styles.hOpen2 : ''}`} />
// //                     <span className={`${styles.hamburger} ${mobileOpen ? styles.hOpen3 : ''}`} />
// //                 </button>
// //             )}

// //             {mobileOpen && isMobile && (
// //                 <div
// //                     className={styles.overlay}
// //                     onClick={() => setMobileOpen(false)}
// //                     aria-hidden="true"
// //                 />
// //             )}

// //             <aside className={sidebarClass}>

// //                 <div className={styles.logo}>
// //                     <div className={styles.logoIcon}>
// //                         <FiDribbble size={18} />
// //                     </div>
// //                     {showLabel && (
// //                         <span className={styles.logoText}>SportsMaster</span>
// //                     )}
// //                 </div>

// //                 <nav className={styles.nav}>
// //                     <ul className={styles.menu}>
// //                         {filtered.map((item) => {
// //                             const Icon      = item.icon;
// //                             const key       = itemKey(item);
// //                             const isActive  = isParentActive(item);
// //                             const hasSub    = !!item.submenu;
// //                             const isOpen    = openSubmenu === key;
// //                             const isHovered = hoveredItem === key;

// //                             return (
// //                                 <li
// //                                     key={key}
// //                                     className={styles.menuLi}
// //                                     ref={(el) => { itemRefs.current[key] = el; }}
// //                                     onMouseEnter={() => handleMouseEnter(item)}
// //                                     onMouseLeave={() => handleMouseLeave(item)}
// //                                 >
// //                                     {hasSub ? (
// //                                         <button
// //                                             className={[
// //                                                 styles.menuItem,
// //                                                 isActive            ? styles.active      : '',
// //                                                 isOpen && showLabel ? styles.submenuOpen : '',
// //                                                 !showLabel          ? styles.iconOnly    : '',
// //                                             ].filter(Boolean).join(' ')}
// //                                             onClick={() => handleParentClick(item)}
// //                                             title={!showLabel ? item.label : undefined}
// //                                         >
// //                                             <span className={styles.iconWrap}><Icon size={16} /></span>
// //                                             {showLabel && (
// //                                                 <>
// //                                                     <span className={styles.label}>{item.label}</span>
// //                                                     <FiChevronDown
// //                                                         size={12}
// //                                                         className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}
// //                                                     />
// //                                                 </>
// //                                             )}
// //                                         </button>
// //                                     ) : (
// //                                         <NavLink
// //                                             to={item.path}
// //                                             className={() => [
// //                                                 styles.menuItem,
// //                                                 isActive   ? styles.active   : '',
// //                                                 !showLabel ? styles.iconOnly : '',
// //                                             ].filter(Boolean).join(' ')}
// //                                             title={!showLabel ? item.label : undefined}
// //                                         >
// //                                             <span className={styles.iconWrap}><Icon size={16} /></span>
// //                                             {showLabel && (
// //                                                 <span className={styles.label}>{item.label}</span>
// //                                             )}
// //                                         </NavLink>
// //                                     )}

// //                                     {hasSub && showLabel && (
// //                                         <ul className={`${styles.submenu} ${isOpen ? styles.submenuVisible : ''}`}>
// //                                             {item.submenu.map((sub) => {
// //                                                 const SubIcon   = sub.icon;
// //                                                 const subActive =
// //                                                     location.pathname === sub.path ||
// //                                                     location.pathname.startsWith(sub.path + '/');
// //                                                 return (
// //                                                     <li key={sub.path}>
// //                                                         <NavLink
// //                                                             to={sub.path}
// //                                                             className={() => [
// //                                                                 styles.submenuItem,
// //                                                                 subActive ? styles.submenuActive : '',
// //                                                             ].filter(Boolean).join(' ')}
// //                                                         >
// //                                                             <span className={styles.submenuDot} />
// //                                                             <SubIcon size={12} className={styles.submenuIcon} />
// //                                                             <span className={styles.submenuLabel}>{sub.label}</span>
// //                                                         </NavLink>
// //                                                     </li>
// //                                                 );
// //                                             })}
// //                                         </ul>
// //                                     )}

// //                                     {hasSub && isDesktopCollapsed && isHovered && (
// //                                         <div
// //                                             className={styles.floatingPopup}
// //                                             style={{ top: popupTop }}
// //                                             onMouseEnter={() => setHoveredItem(key)}
// //                                             onMouseLeave={() => setHoveredItem(null)}
// //                                         >
// //                                             <p className={styles.popupTitle}>{item.label}</p>
// //                                             {item.submenu.map((sub) => {
// //                                                 const SubIcon   = sub.icon;
// //                                                 const subActive =
// //                                                     location.pathname === sub.path ||
// //                                                     location.pathname.startsWith(sub.path + '/');
// //                                                 return (
// //                                                     <NavLink
// //                                                         key={sub.path}
// //                                                         to={sub.path}
// //                                                         className={() => [
// //                                                             styles.popupItem,
// //                                                             subActive ? styles.popupItemActive : '',
// //                                                         ].filter(Boolean).join(' ')}
// //                                                         onClick={() => setHoveredItem(null)}
// //                                                     >
// //                                                         <SubIcon size={12} />
// //                                                         <span>{sub.label}</span>
// //                                                     </NavLink>
// //                                                 );
// //                                             })}
// //                                         </div>
// //                                     )}
// //                                 </li>
// //                             );
// //                         })}
// //                     </ul>
// //                 </nav>

// //                 {!isMobile && (
// //                     <button
// //                         className={styles.toggleBtn}
// //                         onClick={onToggle}
// //                         aria-label={showLabel ? 'Collapse sidebar' : 'Expand sidebar'}
// //                     >
// //                         {showLabel
// //                             ? <FiChevronLeft  size={15} />
// //                             : <FiChevronRight size={15} />
// //                         }
// //                     </button>
// //                 )}
// //             </aside>
// //         </>
// //     );
// // };

// // export default Sidebar;
// // export default Sidebar;
// import { useState, useRef, useEffect, useCallback } from 'react';
// import { NavLink, useLocation, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import {
//     FiHome, FiUsers, FiAward, FiMapPin, FiUser, FiActivity,
//     FiDollarSign, FiShield, FiSettings, FiChevronLeft,
//     FiChevronRight, FiChevronDown, FiKey, FiLock,
//     FiTarget, FiPercent,
//     FiGift,          // Manage Rewards
//     FiCpu,           // Manage AI Coach Assistance
//     FiMoreHorizontal
// } from 'react-icons/fi';
// import styles from './Sidebar.module.scss';

// // ← NEW: import logo image (adjust extension/path if needed)
// const logo1 = require('../../../assets/Logo Image/logo.png');

// const menuItems = [
//     { path: '/dashboard',              icon: FiHome,       label: 'Dashboard',              roles: ['super-admin', 'admin'] },
//     { path: '/sports-management',      icon: FiTarget,     label: 'Sports Management',      roles: ['super-admin', 'admin'] },
//     { path: '/admin-management',       icon: FiShield,     label: 'Vendor Management',      roles: ['super-admin', 'admin'] },
//     { path: '/court-management',       icon: FiMapPin,     label: 'Court Management',       roles: ['super-admin', 'admin','vendor'] },
//     { path: '/tournaments',            icon: FiAward,      label: 'Tournaments Management', roles: ['super-admin', 'admin','vendor'] },
//     { path: '/coach-management',       icon: FiUser,       label: 'Coach Management',       roles: ['super-admin', 'admin','vendor'] },
//     { path: '/player-management',      icon: FiUser,       label: 'Players Management',     roles: ['super-admin', 'admin','vendor'] },
//     { path: '/referee-management',     icon: FiUser,       label: 'Referee Management',     roles: ['super-admin', 'admin','vendor'] },
    
//     { path: '/user-management',        icon: FiUsers,      label: 'Customer Management',    roles: ['super-admin', 'admin'] },
//     {
//         icon: FiSettings,
//         label: 'Roles & Permissions',
//         roles: ['super-admin', 'admin','vendor'],
//         submenu: [
//             { path: '/roles-list',        icon: FiKey,   label: 'Roles'         },
//             { path: '/user-list',         icon: FiUsers, label: 'User Creation' },
//             { path: '/roles-permissions', icon: FiLock,  label: 'Page Access'   },
//         ],
//     },
//     { path: '/payments-revenue',       icon: FiDollarSign, label: 'Payments & Revenue',     roles: ['super-admin', 'admin'] },
//     { path: '/commmission-management', icon: FiPercent,    label: 'Commission Management',  roles: ['super-admin', 'admin'] },
//     {
//     icon: FiMoreHorizontal,
//     label: 'Other',
//     roles: ['super-admin', 'admin'],       // adjust roles as needed
//     submenu: [
//         { path: '/manage-rewards',      icon: FiGift, label: 'Manage Rewards'            },
//         { path: '/ai-coach-assistance', icon: FiCpu,  label: 'Manage AI Coach Assistance' },
//     ],
// },
//     { path: '/live-score-update',      icon: FiActivity,   label: 'Live Score Update',      roles: ['referee', 'super-admin', 'admin'] },
// ];

// export const SIDEBAR_EXPANDED  = 240;
// export const SIDEBAR_COLLAPSED = 62;
// export const BP_MOBILE         = 768;
// export const BP_AUTO_COLLAPSE  = 1280;

// const itemKey = (item) => item.path ?? item.label;

// const Sidebar = ({ collapsed, onToggle, onOpen }) => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const { user } = useSelector((state) => state.auth);

//     const [openSubmenu, setOpenSubmenu] = useState(null);
//     const [hoveredItem, setHoveredItem] = useState(null);
//     const [popupTop,    setPopupTop]    = useState(0);
//     const [mobileOpen,  setMobileOpen]  = useState(false);

//     const [isMobile, setIsMobile] = useState(
//         () => window.innerWidth < BP_MOBILE
//     );
//     const [autoCollapsed, setAutoCollapsed] = useState(
//         () => window.innerWidth < BP_AUTO_COLLAPSE
//     );

//     const itemRefs    = useRef({});
//     const prevAutoCol = useRef(window.innerWidth < BP_AUTO_COLLAPSE);

//     // Resize
//     useEffect(() => {
//         const onResize = () => {
//             const w          = window.innerWidth;
//             const nowMobile  = w < BP_MOBILE;
//             const nowAutoCol = w < BP_AUTO_COLLAPSE;

//             setIsMobile(nowMobile);
//             setAutoCollapsed(nowAutoCol);
//             if (nowMobile) setMobileOpen(false);

//             if (prevAutoCol.current !== nowAutoCol) {
//                 onOpen();
//                 prevAutoCol.current = nowAutoCol;
//             }
//         };
//         window.addEventListener('resize', onResize);
//         return () => window.removeEventListener('resize', onResize);
//     }, [onOpen]);

//     // Close drawer on navigation
//     useEffect(() => { setMobileOpen(false); }, [location.pathname]);

//     // Keep submenu open for active child route
//     useEffect(() => {
//         const active = menuItems.find(
//             (item) => item.submenu?.some(
//                 (sub) =>
//                     location.pathname === sub.path ||
//                     location.pathname.startsWith(sub.path + '/')
//             )
//         );
//         setOpenSubmenu(active ? itemKey(active) : null);
//     }, [location.pathname]);

//     // autoCollapsed=true  -> default CLOSED (so collapsed=false means open)
//     // autoCollapsed=false -> default OPEN   (so collapsed=true  means closed)
//     const isDesktopCollapsed = !isMobile && (autoCollapsed ? !collapsed : collapsed);
//     const showLabel          = isMobile ? mobileOpen : !isDesktopCollapsed;

//     useEffect(() => {
//         if (isDesktopCollapsed) setOpenSubmenu(null);
//     }, [isDesktopCollapsed]);

//     const filtered = menuItems.filter(
//         (item) => !user || item.roles.includes(user.role)
//     );

//     const isParentActive = (item) => {
//         if (item.submenu) {
//             return item.submenu.some(
//                 (sub) =>
//                     location.pathname === sub.path ||
//                     location.pathname.startsWith(sub.path + '/')
//             );
//         }
//         if (!item.path) return false;
//         return (
//             location.pathname === item.path ||
//             location.pathname.startsWith(item.path + '/')
//         );
//     };

//     const handleParentClick = (item) => {
//         if (!item.submenu) return;
//         if (showLabel) {
//             const key = itemKey(item);
//             setOpenSubmenu((prev) => (prev === key ? null : key));
//         } else {
//             navigate(item.submenu[0].path);
//         }
//     };

//     const handleMouseEnter = useCallback((item) => {
//         if (!item.submenu || !isDesktopCollapsed) return;
//         const key = itemKey(item);
//         const el  = itemRefs.current[key];
//         if (el) setPopupTop(el.getBoundingClientRect().top);
//         setHoveredItem(key);
//     }, [isDesktopCollapsed]);

//     const handleMouseLeave = useCallback((item) => {
//         if (!item.submenu || !isDesktopCollapsed) return;
//         setHoveredItem(null);
//     }, [isDesktopCollapsed]);

//     const sidebarClass = [
//         styles.sidebar,
//         isDesktopCollapsed ? styles.collapsed  : '',
//         mobileOpen         ? styles.mobileOpen : '',
//     ].filter(Boolean).join(' ');

//     return (
//         <>
//             {isMobile && (
//                 <button
//                     className={styles.mobileToggle}
//                     onClick={() => setMobileOpen((p) => !p)}
//                     aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
//                 >
//                     <span className={`${styles.hamburger} ${mobileOpen ? styles.hOpen1 : ''}`} />
//                     <span className={`${styles.hamburger} ${mobileOpen ? styles.hOpen2 : ''}`} />
//                     <span className={`${styles.hamburger} ${mobileOpen ? styles.hOpen3 : ''}`} />
//                 </button>
//             )}

//             {mobileOpen && isMobile && (
//                 <div
//                     className={styles.overlay}
//                     onClick={() => setMobileOpen(false)}
//                     aria-hidden="true"
//                 />
//             )}

//             <aside className={sidebarClass}>

//                 {/* LOGO: use logo1.png instead of FiDribbble */}
//                 <div className={styles.logo}>
//                     <div className={styles.logoIcon}>
//                         <img
//                             src={logo1}
//                             alt="SportsMaster"
//                             className={styles.logoImg}
//                         />
//                     </div>
//                     {/* {showLabel && (
//                         <span className={styles.logoText}>SportsMaster</span>
//                     )} */}
//                 </div>

//                 <nav className={styles.nav}>
//                     <ul className={styles.menu}>
//                         {filtered.map((item) => {
//                             const Icon      = item.icon;
//                             const key       = itemKey(item);
//                             const isActive  = isParentActive(item);
//                             const hasSub    = !!item.submenu;
//                             const isOpen    = openSubmenu === key;
//                             const isHovered = hoveredItem === key;

//                             return (
//                                 <li
//                                     key={key}
//                                     className={styles.menuLi}
//                                     ref={(el) => { itemRefs.current[key] = el; }}
//                                     onMouseEnter={() => handleMouseEnter(item)}
//                                     onMouseLeave={() => handleMouseLeave(item)}
//                                 >
//                                     {hasSub ? (
//                                         <button
//                                             className={[
//                                                 styles.menuItem,
//                                                 isActive            ? styles.active      : '',
//                                                 isOpen && showLabel ? styles.submenuOpen : '',
//                                                 !showLabel          ? styles.iconOnly    : '',
//                                             ].filter(Boolean).join(' ')}
//                                             onClick={() => handleParentClick(item)}
//                                             title={!showLabel ? item.label : undefined}
//                                         >
//                                             <span className={styles.iconWrap}><Icon size={16} /></span>
//                                             {showLabel && (
//                                                 <>
//                                                     <span className={styles.label}>{item.label}</span>
//                                                     <FiChevronDown
//                                                         size={12}
//                                                         className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}
//                                                     />
//                                                 </>
//                                             )}
//                                         </button>
//                                     ) : (
//                                         <NavLink
//                                             to={item.path}
//                                             className={() => [
//                                                 styles.menuItem,
//                                                 isActive   ? styles.active   : '',
//                                                 !showLabel ? styles.iconOnly : '',
//                                             ].filter(Boolean).join(' ')}
//                                             title={!showLabel ? item.label : undefined}
//                                         >
//                                             <span className={styles.iconWrap}><Icon size={16} /></span>
//                                             {showLabel && (
//                                                 <span className={styles.label}>{item.label}</span>
//                                             )}
//                                         </NavLink>
//                                     )}

//                                     {hasSub && showLabel && (
//                                         <ul className={`${styles.submenu} ${isOpen ? styles.submenuVisible : ''}`}>
//                                             {item.submenu.map((sub) => {
//                                                 const SubIcon   = sub.icon;
//                                                 const subActive =
//                                                     location.pathname === sub.path ||
//                                                     location.pathname.startsWith(sub.path + '/');
//                                                 return (
//                                                     <li key={sub.path}>
//                                                         <NavLink
//                                                             to={sub.path}
//                                                             className={() => [
//                                                                 styles.submenuItem,
//                                                                 subActive ? styles.submenuActive : '',
//                                                             ].filter(Boolean).join(' ')}
//                                                         >
//                                                             <span className={styles.submenuDot} />
//                                                             <SubIcon size={12} className={styles.submenuIcon} />
//                                                             <span className={styles.submenuLabel}>{sub.label}</span>
//                                                         </NavLink>
//                                                     </li>
//                                                 );
//                                             })}
//                                         </ul>
//                                     )}

//                                     {hasSub && isDesktopCollapsed && isHovered && (
//                                         <div
//                                             className={styles.floatingPopup}
//                                             style={{ top: popupTop }}
//                                             onMouseEnter={() => setHoveredItem(key)}
//                                             onMouseLeave={() => setHoveredItem(null)}
//                                         >
//                                             <p className={styles.popupTitle}>{item.label}</p>
//                                             {item.submenu.map((sub) => {
//                                                 const SubIcon   = sub.icon;
//                                                 const subActive =
//                                                     location.pathname === sub.path ||
//                                                     location.pathname.startsWith(sub.path + '/');
//                                                 return (
//                                                     <NavLink
//                                                         key={sub.path}
//                                                         to={sub.path}
//                                                         className={() => [
//                                                             styles.popupItem,
//                                                             subActive ? styles.popupItemActive : '',
//                                                         ].filter(Boolean).join(' ')}
//                                                         onClick={() => setHoveredItem(null)}
//                                                     >
//                                                         <SubIcon size={12} />
//                                                         <span>{sub.label}</span>
//                                                     </NavLink>
//                                                 );
//                                             })}
//                                         </div>
//                                     )}
//                                 </li>
//                             );
//                         })}
//                     </ul>
//                 </nav>

//                 {!isMobile && (
//                     <button
//                         className={styles.toggleBtn}
//                         onClick={onToggle}
//                         aria-label={showLabel ? 'Collapse sidebar' : 'Expand sidebar'}
//                     >
//                         {showLabel
//                             ? <FiChevronLeft  size={15} />
//                             : <FiChevronRight size={15} />
//                         }
//                     </button>
//                 )}
//             </aside>
//         </>
//     );
// };

// export default Sidebar;
import { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  FiHome,
  FiUsers,
  FiAward,
  FiMapPin,
  FiClipboard,
  FiCalendar,
  FiUser,
  FiActivity,
  FiDollarSign,
  FiShield,
  FiSettings,
  FiChevronLeft,
  FiChevronRight,
  FiChevronDown,
  FiKey,
  FiLock,
  FiTarget,
  FiPercent,
  FiGift,
  FiCpu,
  FiMoreHorizontal,
  FiMessageCircle,
} from 'react-icons/fi';
import styles from './Sidebar.module.scss';

const logo1 = require('../../../assets/Logo Image/logo.png');



const menuItems = [
  {
    path: '/dashboard',
    icon: FiHome,
    label: 'Dashboard',
    permission: 'dashboard_view',
    activePaths: ['/dashboard', '/'],
  },
  {
    path: '/sports-management',
    icon: FiTarget,
    label: 'Sports Management',
    permission: 'sports_management_view',
    activePaths: ['/sports-management'],
  },
  {
    path: '/admin-management',
    icon: FiShield,
    label: 'Vendor Management',
    permission: 'admin_management_view',
    activePaths: ['/admin-management'],
  },
  {
    path: '/court-management',
    icon: FiMapPin,
    label: 'Court Management',
    permission: 'court_management_view',
    activePaths: ['/court-management'],
  },
  {
    path: '/tournaments',
    icon: FiAward,
    label: 'Tournaments Management',
    permission: 'tournament_management_view',
    activePaths: ['/tournaments'],
  },
  {
    path: '/coach-management',
    icon: FiUser,
    label: 'Coach Management',
    permission: 'coach_management_view',
    activePaths: ['/coach-management'],
  },
  {
    path: '/player-management',
    icon: FiUser,
    label: 'Players Management',
    permission: 'player_management_view',
    activePaths: ['/player-management'],
  },
  {
    path: '/referee-management',
    icon: FiUser,
    label: 'Referee Management',
    permission: 'referee_management_view',
    activePaths: ['/referee-management'],
  },
  {
    path: '/user-management',
    icon: FiUsers,
    label: 'Customer Management',
    permission: 'customer_management_view',
    activePaths: ['/user-management'],
  },
  {
    icon: FiSettings,
    label: 'Roles & Permissions',
    permission: null,
    activePaths: ['/roles-list', '/user-list', '/roles-permissions'],
    submenu: [
      {
        path: '/roles-list',
        icon: FiKey,
        label: 'Roles',
        permission: 'roles_view',
      },
      {
        path: '/user-list',
        icon: FiUsers,
        label: 'User Creation',
        permission: 'page_access_manage',
      },
      {
        path: '/roles-permissions',
        icon: FiLock,
        label: 'Page Access',
        permission: 'page_access_manage',
      },
    ],
  },
  {
    path: '/payments-revenue',
    icon: FiDollarSign,
    label: 'Payments & Revenue',
    permission: 'payments_revenue_view',
    activePaths: ['/payments-revenue'],
  },
  {
    path: '/commmission-management',
    icon: FiPercent,
    label: 'Commission Management',
    permission: 'commission_management_view',
    activePaths: ['/commmission-management'],
  },
  {
    icon: FiMoreHorizontal,
    label: 'Other',
    permission: null,
    activePaths: ['/manage-rewards', '/ai-coach-assistance'],
    submenu: [
      {
        path: '/manage-rewards',
        icon: FiGift,
        label: 'Manage Rewards',
        permission: 'manage_rewards_view',
      },
      {
        path: '/ai-coach-assistance',
        icon: FiCpu,
        label: 'Manage AI Coach Assistance',
        permission: 'ai_coach_assistance_view',
      },
    ],
  },

   {
    path: '/contact-support',
    icon: FiMessageCircle,
    label: 'Contact Support',
    permission: 'contact_support_view',
    activePaths: ['/contact-support'],
  },
  
  
  {
    path: '/live-score-update',
    icon: FiActivity,
    label: 'Live Score Update',
    permission: 'live_score_update_view',
    activePaths: ['/live-score-update'],
  },
];
const coachMenuItem = {
  icon: FiClipboard, // import FiClipboard from 'react-icons/fi'
  label: 'View Registration',
  permission: null,
  activePaths: ['/coach/registrations', '/coach/monthly-registration'],
  submenu: [
    {
      path: '/coach/registrations',
      icon: FiUser,
      label: 'Registrations',
      permission: null,
    },
    {
      path: '/coach/monthly-registration',
      icon: FiCalendar, // already imported in your WeeklyScheduleView section
      label: 'Monthly Registration',
      permission: null,
    },
  ],
};

export const SIDEBAR_EXPANDED = 240;
export const SIDEBAR_COLLAPSED = 62;
export const BP_MOBILE = 768;
export const BP_AUTO_COLLAPSE = 1280;

const itemKey = (item) => item.path ?? item.label;

const hasPermission = (permissions, permission) => {
  if (!permission) return true;
  return permissions?.[permission] === true;
};

const isPathMatched = (pathname, activePaths = [], exactPath = null) => {
  if (exactPath && (pathname === exactPath || pathname.startsWith(`${exactPath}/`))) {
    return true;
  }

  return activePaths.some((basePath) => {
    if (basePath === '/') return pathname === '/';
    return pathname === basePath || pathname.startsWith(`${basePath}/`);
  });
};



const Sidebar = ({ collapsed, onToggle, onOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  // const { permissions = {} } = useSelector((state) => state.auth);
  const { permissions = {}, role } = useSelector((state) => state.auth); // updated line
  const isCoach = String(role || '').toLowerCase() === 'coach'; // add this right after

  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [popupTop, setPopupTop] = useState(0);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(() => window.innerWidth < BP_MOBILE);
  const [autoCollapsed, setAutoCollapsed] = useState(() => window.innerWidth < BP_AUTO_COLLAPSE);

  const itemRefs = useRef({});
  const prevAutoCol = useRef(window.innerWidth < BP_AUTO_COLLAPSE);

  useEffect(() => {
    const onResize = () => {
      const width = window.innerWidth;
      const nowMobile = width < BP_MOBILE;
      const nowAutoCol = width < BP_AUTO_COLLAPSE;

      setIsMobile(nowMobile);
      setAutoCollapsed(nowAutoCol);

      if (nowMobile) setMobileOpen(false);

      if (prevAutoCol.current !== nowAutoCol) {
        onOpen?.();
        prevAutoCol.current = nowAutoCol;
      }
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [onOpen]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  // const filteredMenuItems = useMemo(() => {
  //   return menuItems
  //     .map((item) => {
  //       if (item.submenu?.length) {
  //         const filteredSubmenu = item.submenu.filter((sub) =>
  //           hasPermission(permissions, sub.permission)
  //         );

  //         if (!filteredSubmenu.length) return null;

  //         return {
  //           ...item,
  //           submenu: filteredSubmenu,
  //         };
  //       }

  //       if (!hasPermission(permissions, item.permission)) {
  //         return null;
  //       }

  //       return item;
  //     })
  //     .filter(Boolean);
  // }, [permissions]);
  const filteredMenuItems = useMemo(() => {
  const baseItems = isCoach ? [...menuItems, coachMenuItem] : menuItems;

  return baseItems
    .map((item) => {
      if (item.submenu?.length) {
        const filteredSubmenu = item.submenu.filter((sub) =>
          hasPermission(permissions, sub.permission)
        );
        if (!filteredSubmenu.length) return null;
        return { ...item, submenu: filteredSubmenu };
      }
      if (!hasPermission(permissions, item.permission)) return null;
      return item;
    })
    .filter(Boolean);
}, [permissions, isCoach]);

  useEffect(() => {
    const activeParent = filteredMenuItems.find((item) => {
      if (!item.submenu?.length) return false;

      return item.submenu.some(
        (sub) =>
          location.pathname === sub.path ||
          location.pathname.startsWith(`${sub.path}/`)
      );
    });

    setOpenSubmenu(activeParent ? itemKey(activeParent) : null);
  }, [location.pathname, filteredMenuItems]);

  const isDesktopCollapsed = !isMobile && (autoCollapsed ? !collapsed : collapsed);
  const showLabel = isMobile ? mobileOpen : !isDesktopCollapsed;

  useEffect(() => {
    if (isDesktopCollapsed) {
      setOpenSubmenu(null);
    }
  }, [isDesktopCollapsed]);

  const isParentActive = useCallback(
    (item) => {
      if (item.submenu?.length) {
        return item.submenu.some(
          (sub) =>
            location.pathname === sub.path ||
            location.pathname.startsWith(`${sub.path}/`)
        );
      }

      return isPathMatched(location.pathname, item.activePaths || [], item.path);
    },
    [location.pathname]
  );

  const handleParentClick = (item) => {
    if (!item.submenu?.length) return;

    if (showLabel) {
      const key = itemKey(item);
      setOpenSubmenu((prev) => (prev === key ? null : key));
    } else {
      navigate(item.submenu[0].path);
    }
  };

  const handleMouseEnter = useCallback(
    (item) => {
      if (!item.submenu?.length || !isDesktopCollapsed) return;

      const key = itemKey(item);
      const el = itemRefs.current[key];

      if (el) {
        setPopupTop(el.getBoundingClientRect().top);
      }

      setHoveredItem(key);
    },
    [isDesktopCollapsed]
  );

  const handleMouseLeave = useCallback(
    () => {
      if (!isDesktopCollapsed) return;
      setHoveredItem(null);
    },
    [isDesktopCollapsed]
  );

  const sidebarClass = [
    styles.sidebar,
    isDesktopCollapsed ? styles.collapsed : '',
    mobileOpen ? styles.mobileOpen : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      {isMobile && (
        <button
          className={styles.mobileToggle}
          onClick={() => setMobileOpen((prev) => !prev)}
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          type="button"
        >
          <span className={`${styles.hamburger} ${mobileOpen ? styles.hOpen1 : ''}`} />
          <span className={`${styles.hamburger} ${mobileOpen ? styles.hOpen2 : ''}`} />
          <span className={`${styles.hamburger} ${mobileOpen ? styles.hOpen3 : ''}`} />
        </button>
      )}

      {mobileOpen && isMobile && (
        <div
          className={styles.overlay}
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      <aside className={sidebarClass}>
        <div className={styles.logo}>
          <div className={styles.logoIcon}>
            <img
              src={logo1}
              alt="SportsMaster"
              className={styles.logoImg}
            />
          </div>
        </div>

        <nav className={styles.nav}>
          <ul className={styles.menu}>
            {filteredMenuItems.map((item) => {
              const Icon = item.icon;
              const key = itemKey(item);
              const isActive = isParentActive(item);
              const hasSub = !!item.submenu?.length;
              const isOpen = openSubmenu === key;
              const isHovered = hoveredItem === key;

              return (
                <li
                  key={key}
                  className={styles.menuLi}
                  ref={(el) => {
                    itemRefs.current[key] = el;
                  }}
                  onMouseEnter={() => handleMouseEnter(item)}
                  onMouseLeave={handleMouseLeave}
                >
                  {hasSub ? (
                    <button
                      className={[
                        styles.menuItem,
                        isActive ? styles.active : '',
                        isOpen && showLabel ? styles.submenuOpen : '',
                        !showLabel ? styles.iconOnly : '',
                      ]
                        .filter(Boolean)
                        .join(' ')}
                      onClick={() => handleParentClick(item)}
                      title={!showLabel ? item.label : undefined}
                      type="button"
                    >
                      <span className={styles.iconWrap}>
                        <Icon size={16} />
                      </span>

                      {showLabel && (
                        <>
                          <span className={styles.label}>{item.label}</span>
                          <FiChevronDown
                            size={12}
                            className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}
                          />
                        </>
                      )}
                    </button>
                  ) : (
                    <NavLink
                      to={item.path}
                      className={() =>
                        [
                          styles.menuItem,
                          isActive ? styles.active : '',
                          !showLabel ? styles.iconOnly : '',
                        ]
                          .filter(Boolean)
                          .join(' ')
                      }
                      title={!showLabel ? item.label : undefined}
                    >
                      <span className={styles.iconWrap}>
                        <Icon size={16} />
                      </span>

                      {showLabel && <span className={styles.label}>{item.label}</span>}
                    </NavLink>
                  )}

                  {hasSub && showLabel && (
                    <ul className={`${styles.submenu} ${isOpen ? styles.submenuVisible : ''}`}>
                      {item.submenu.map((sub) => {
                        const SubIcon = sub.icon;
                        const subActive =
                          location.pathname === sub.path ||
                          location.pathname.startsWith(`${sub.path}/`);

                        return (
                          <li key={sub.path}>
                            <NavLink
                              to={sub.path}
                              className={() =>
                                [
                                  styles.submenuItem,
                                  subActive ? styles.submenuActive : '',
                                ]
                                  .filter(Boolean)
                                  .join(' ')
                              }
                            >
                              <span className={styles.submenuDot} />
                              <SubIcon size={12} className={styles.submenuIcon} />
                              <span className={styles.submenuLabel}>{sub.label}</span>
                            </NavLink>
                          </li>
                        );
                      })}
                    </ul>
                  )}

                  {hasSub && isDesktopCollapsed && isHovered && (
                    <div
                      className={styles.floatingPopup}
                      style={{ top: popupTop }}
                      onMouseEnter={() => setHoveredItem(key)}
                      onMouseLeave={() => setHoveredItem(null)}
                    >
                      <p className={styles.popupTitle}>{item.label}</p>

                      {item.submenu.map((sub) => {
                        const SubIcon = sub.icon;
                        const subActive =
                          location.pathname === sub.path ||
                          location.pathname.startsWith(`${sub.path}/`);

                        return (
                          <NavLink
                            key={sub.path}
                            to={sub.path}
                            className={() =>
                              [
                                styles.popupItem,
                                subActive ? styles.popupItemActive : '',
                              ]
                                .filter(Boolean)
                                .join(' ')
                            }
                            onClick={() => setHoveredItem(null)}
                          >
                            <SubIcon size={12} />
                            <span>{sub.label}</span>
                          </NavLink>
                        );
                      })}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>

        {!isMobile && (
          <button
            className={styles.toggleBtn}
            onClick={onToggle}
            aria-label={showLabel ? 'Collapse sidebar' : 'Expand sidebar'}
            type="button"
          >
            {showLabel ? <FiChevronLeft size={15} /> : <FiChevronRight size={15} />}
          </button>
        )}
      </aside>
    </>
  );
};

export default Sidebar;